import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TrainingProgramListComponent } from './trainingprogram-list.component';

import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from "../shared/services/AuthGuard.service";


@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      { path: "trainingprograms/:programId/:activityId", component: TrainingProgramListComponent, canActivate: [AuthGuard], canDeactivate: [] },
      { path: "trainingprograms/:programId", component: TrainingProgramListComponent, canActivate: [AuthGuard], canDeactivate: [] },
      { path: "trainingprograms", component: TrainingProgramListComponent, canActivate: [AuthGuard], canDeactivate: [] },
      { path: "trainingprograms/**", component: TrainingProgramListComponent, canActivate: [AuthGuard], canDeactivate: [] },
    ]),
  ],
  declarations: [
    TrainingProgramListComponent
  ],
  exports: [],
  providers: [AuthGuard],
  entryComponents: [],
  bootstrap: []
})
export class TrainingProgramModule { }
